/**
 * Utility functions for campaign tracking
 */

/**
 * Extract campaign parameters from URL
 * @param {string} url - The URL to extract parameters from
 * @returns {Object} Campaign parameters
 */
export const extractCampaignParams = (url) => {
  const urlObj = new URL(url);
  const params = urlObj.searchParams;
  
  return {
    cmpg_identifier: params.get('cmpg_identifier'),
  };
};

/**
 * Detect source from referrer URL
 * @param {string} referrer - The referrer URL
 * @returns {string|null} Detected source or null
 */
export const detectSourceFromReferrer = (referrer) => {
  if (!referrer) return null;
  
  try {
    const referrerUrl = new URL(referrer);
    const hostname = referrerUrl.hostname.toLowerCase();
    
    // Only detect these 4 sources
    const sourceMap = {
      'google.com': 'google',
      'google.co.uk': 'google',
      'google.ca': 'google',
      'google.com.au': 'google',
      'facebook.com': 'facebook',
      'fb.com': 'facebook',
      'instagram.com': 'instagram',
      'linkedin.com': 'linkedin',
    };
    
    // Check for exact matches
    if (sourceMap[hostname]) {
      return sourceMap[hostname];
    }
    
    // Check for partial matches (subdomains)
    for (const [domain, source] of Object.entries(sourceMap)) {
      if (hostname.includes(domain)) {
        return source;
      }
    }
    
    // If no match found, return "unknown"
    return "unknown";
  } catch (error) {
    return null;
  }
};
